<template>
    <div class="card">
        <div class="card-body">
            <div class="font-weight-bold mb-4">
                Общая информация
                <a target="_blank" :href="getKBLink('profile')" class="btn btn-link text-nowrap ml-2 px-0"><i class="tlm-icon-question-circle" /></a>
            </div>

            <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
                <div class="row">
                    <ValidationProvider v-errors.api vid="user_first_name" tag="div" class="form-group col-12 col-md-6" rules="required|max:200">
                        <input v-model="form.user_first_name" type="text" class="form-control" maxlength="200" placeholder="Имя">
                    </ValidationProvider>

                    <ValidationProvider v-errors.api vid="user_last_name" tag="div" class="form-group col-12 col-md-6" rules="required|max:200">
                        <input v-model="form.user_last_name" type="text" class="form-control" maxlength="200" placeholder="Фамилия">
                    </ValidationProvider>
                </div>

                <ValidationProvider v-errors.api vid="name" tag="div" class="form-group" rules="required|max:200">
                    <input v-model="form.name" type="text" class="form-control" maxlength="200" placeholder="Название организации">
                </ValidationProvider>

                <div class="row mb-2">
                    <ValidationProvider v-errors.api vid="user_email" tag="div" class="form-group col-12 col-md-6" rules="required">
                        <label for="email">Эл. почта</label>
                        <input id="email" v-model="form.user_email" type="text" maxlength="100" class="form-control">
                    </ValidationProvider>

                    <ValidationProvider v-errors.api vid="tz_id" tag="div" class="form-group col-12 col-md-6" rules="required">
                        <label for="tz_id">Часовой пояс</label>
                        <select-timezone id="tz_id" v-model="form.tz_id" class="form-control" />
                    </ValidationProvider>
                </div>

                <div>
                    <button type="submit" class="btn btn-primary btn-lg-192" :disabled="invalid || pending">Сохранить</button>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
import SelectTimezone from '@/components/SelectTimezone'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mixinApiErrors } from '@/validation'

import KBLinksService from '@/services/KBLinksService'

const fillForm = company => ({
    name: company.name,
    tz_id: company.tz_id,
    user_first_name: company.user_first_name,
    user_last_name: company.user_last_name,
    user_email: company.user_email
})

export default {
    components: {
        SelectTimezone,
        ValidationObserver,
        ValidationProvider
    },

    props: {
        pending: {
            type: Boolean,
            default: false
        },

        company: {
            type: Object,
            default: _ => ({})
        }
    },

    data() {
        return {
            form: fillForm(this.company)
        }
    },

    watch: {
        company: {
            deep: true,
            handler(company, a) { this.form = fillForm(company) }
        }
    },

    methods: {
        submit() {
            this.$emit('update', this.form)
        },

        mixinApiErrors(errors) {
            mixinApiErrors(this.$refs.obs, errors)
        },

        getKBLink(key) {
            return KBLinksService.get(key)
        }
    }
}
</script>
